'use client';

import React, { useState, useEffect } from 'react';
import { Bell, Search, RefreshCw, Wifi } from 'lucide-react';

export default function Topbar() {
  const [currentTime, setCurrentTime] = useState('');
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    const update = () => {
      setCurrentTime(new Date()?.toISOString()?.replace('T', ' ')?.substring(0, 19) + ' UTC');
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleRefresh = () => {
    setRefreshing(true);
    setTimeout(() => setRefreshing(false), 1200);
  };

  return (
    <header className="h-14 bg-surface border-b border-border flex items-center justify-between px-6 flex-shrink-0">
      {/* Left: search */}
      <div className="flex items-center gap-3">
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted" />
          <input
            type="text"
            placeholder="Search nodes, incidents, tickets… (⌘K)"
            className="pl-8 pr-4 py-1.5 text-sm bg-surface-raised border border-border rounded-lg text-foreground placeholder:text-muted focus:outline-none focus:border-primary/50 w-72 transition-colors"
          />
        </div>
      </div>

      {/* Right: status + actions */}
      <div className="flex items-center gap-4">
        {/* Live indicator */}
        <div className="flex items-center gap-1.5">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-success" />
          </span>
          <span className="text-[11px] font-mono text-success">LIVE</span>
        </div>

        {/* Telemetry rate */}
        <div className="flex items-center gap-1.5 text-[11px] font-mono text-muted">
          <Wifi size={12} />
          <span>48.2k events/s</span>
        </div>

        {/* Timestamp */}
        <span className="text-[11px] font-mono text-muted hidden lg:block">{currentTime}</span>

        {/* Refresh */}
        <button
          onClick={handleRefresh}
          className="p-1.5 rounded-lg hover:bg-surface-raised text-muted hover:text-foreground transition-all duration-150 active:scale-95"
          title="Refresh data"
        >
          <RefreshCw size={15} className={refreshing ? 'animate-spin text-primary' : ''} />
        </button>

        {/* Notifications */}
        <button className="relative p-1.5 rounded-lg hover:bg-surface-raised text-muted hover:text-foreground transition-all duration-150 active:scale-95">
          <Bell size={15} />
          <span className="absolute top-0.5 right-0.5 w-1.5 h-1.5 rounded-full bg-danger" />
        </button>

        {/* User */}
        <div className="w-7 h-7 rounded-full bg-primary/20 flex items-center justify-center text-primary text-xs font-bold cursor-pointer hover:bg-primary/30 transition-colors">
          DT
        </div>
      </div>
    </header>
  );
}